var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fancy-progress"},[_c('div',{staticClass:"shadow",style:(`background-color:${_vm.assignee.color}`)}),_c('FancyProgressBarContent',{attrs:{"name":_vm.assignee.value,"id":_vm.assignee.key,"icon":_vm.assignee.icon,"progress":_vm.assignee.progress,"color":_vm.assignee.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }